var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoDashRelatoriosInteligentes01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "analytics_1_",
    transform: "translate(6 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1000_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_508_1_",
    d: "M27.9,9.8h-4.1c-0.4,0-0.7,0.3-0.6,0.7v3.5c0,0.4,0.2,0.7,0.6,0.7s0.7-0.2,0.7-0.6c0,0,0-0.1,0-0.1 v-2.8h2.8v18h-2.8V19c0-0.4-0.2-0.7-0.6-0.7c-0.4,0-0.7,0.2-0.7,0.6c0,0,0,0.1,0,0.1v10.1h-1.3V15c0-0.4-0.3-0.7-0.6-0.7H17 c-0.4,0-0.7,0.3-0.6,0.7v14.2h-1.3v-9.4c0-0.4-0.3-0.7-0.6-0.7h-4.1c-0.4,0-0.7,0.3-0.6,0.7v9.4H8.4v-5.4c0-0.4-0.3-0.7-0.6-0.7 H3.6c-0.4,0-0.7,0.3-0.6,0.7v5.4h-5.6c-0.4,0-0.7-0.3-0.6-0.7V-2.5c0-0.4,0.3-0.7,0.6-0.7h16.7v4.5c0,1.1,0.8,2,1.9,2.1h4.3v8.4 c0,0.4,0.2,0.7,0.6,0.7c0.4,0,0.7-0.2,0.7-0.6c0,0,0-0.1,0-0.1V2.7c0-0.2-0.1-0.4-0.2-0.5l-6.2-6.6c-0.1-0.1-0.3-0.2-0.5-0.2H-2.6 c-1.1,0-2,1-1.9,2.1v30.9c0,1.1,0.8,2,1.9,2.1h30.5c0.4,0,0.7-0.3,0.6-0.7V10.5C28.6,10.1,28.3,9.8,27.9,9.8z M15.4-2.2l4,4.2H16 c-0.4,0-0.7-0.3-0.6-0.7V-2.2z M7.1,29.2H4.2v-4.8h2.8V29.2z M13.8,29.2H11v-8.7h2.8L13.8,29.2z M20.5,29.2h-2.8V15.7h2.8 L20.5,29.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1002_1_",
    transform: "translate(32.573 23.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_509_1_",
    d: "M-7.7-7.2c-0.2-0.2-0.6-0.2-0.8,0c-0.2,0.2-0.2,0.6,0,0.8c0.2,0.2,0.6,0.2,0.8,0 c0.1-0.1,0.2-0.2,0.2-0.4C-7.5-7-7.6-7.1-7.7-7.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1004_1_",
    transform: "translate(3.338 3.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_510_1_",
    d: "M0-4.9c-0.3,0-0.5,0.2-0.5,0.5c0,0,0,0,0,0v1C-3.3-3.1-5.3-0.6-5,2.1c0.3,2.8,2.8,4.7,5.5,4.4 C2.9,6.3,4.8,4.5,5,2.1h1c0.3,0,0.5-0.2,0.5-0.5v0C6.6-2,3.6-4.9,0-4.9z M0,5.5c-2.2,0-3.9-1.8-3.9-3.9c0-2,1.4-3.6,3.4-3.9v3.9 c0,0.3,0.2,0.5,0.5,0.5c0,0,0,0,0,0h3.9C3.7,4.1,2,5.5,0,5.5z M0.6,1L0.6,1v-4.9C3.1-3.6,5.2-1.5,5.4,1L0.6,1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1006_1_",
    transform: "translate(3.363 23.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_511_1_",
    d: "M6-7.4H-4.4C-4.7-7.4-5-7.2-5-6.9c0,0.3,0.2,0.6,0.5,0.6c0,0,0,0,0,0H6c0.3,0,0.6-0.2,0.6-0.5 C6.6-7.1,6.3-7.4,6-7.4C6-7.4,6-7.4,6-7.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1008_1_",
    transform: "translate(3.363 26.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_512_1_",
    d: "M-0.9-7.8h-3.5C-4.7-7.9-5-7.6-5-7.3C-5-7-4.8-6.8-4.5-6.8c0,0,0,0,0,0h3.5c0.3,0,0.6-0.2,0.6-0.5 C-0.4-7.6-0.6-7.8-0.9-7.8C-0.9-7.8-0.9-7.8-0.9-7.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1010_1_",
    transform: "translate(12.489 26.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_513_1_",
    d: "M-5.2-7.7c-0.2-0.2-0.6-0.2-0.8,0c-0.2,0.2-0.2,0.6,0,0.8c0.2,0.2,0.6,0.2,0.8,0C-5.1-7-5-7.2-5-7.3 C-5-7.4-5.1-7.6-5.2-7.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDashRelatoriosInteligentes01);
export default __webpack_public_path__ + "static/media/ico-dash-relatorios-inteligentes-01.7005952c716305e770d3b7518d14adcc.svg";
export { ForwardRef as ReactComponent };